<template>
    <div class="form-group">
      <label for="quest">Quest (example: @quest/chapter_01/0110_change_vase)</label>
      <input v-model="questStr" id="quest" class="form-control" required>
    </div>
</template>

<script>
import { getProtoId } from '../util';

export default {
  name: 'PlayerPendingAddDataInputRewindStoryToQuest',

  data() {
    return {
      questStr: '',
    };
  },

  methods: {
    fillFormData(formData) {
      const trimmedQuestStr = this.questStr.trim();
      if(trimmedQuestStr.length === 0) {
        return new Error('Quest must be specified.');
      }

      const questProtoId = getProtoId(trimmedQuestStr);
      if(questProtoId === null) {
        return new Error(`Quest ${trimmedQuestStr} is not found.`);
      }

      formData.append('quest_id', questProtoId);

      return null;
    },
  },
}
</script>
